module.exports = __webpack_public_path__ + "vue-app/img/phone.c021469b.svg";